import React from "react";

import { Navigate, Route, Routes } from "react-router-dom";

import ROUTES from "@app/common/routes";

import IncompleteMeetingReports from "./IncompleteMeetingReports";
import MeetingReports from "./MeetingReports";
import Reports from "./Reports";
import SearchResults from "./SearchResults";
import SharedWithMe from "./SharedWithMe";

const ReportsRoutes = () => {
  return (
    <Routes>
      <Route element={<MeetingReports />}>
        <Route index element={<Reports />} />
        <Route path="shared" element={<SharedWithMe />} />
        <Route path="incomplete" element={<IncompleteMeetingReports />} />
        <Route path="search" element={<SearchResults />} />
        <Route path="*" element={<Navigate to={ROUTES.REPORTS} replace />} />
      </Route>
    </Routes>
  );
};

export default ReportsRoutes;
